import { render } from "./AdmissionLinkCard.vue?vue&type=template&id=6c32fa14&scoped=true"
import script from "./AdmissionLinkCard.vue?vue&type=script&lang=js"
export * from "./AdmissionLinkCard.vue?vue&type=script&lang=js"

import "./AdmissionLinkCard.vue?vue&type=style&index=0&id=6c32fa14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c32fa14"]])

export default __exports__